<popup-header [icon]="'close'"
              (clickAction)="cancelAction()"
              [text]="'Date Range'">
</popup-header>

<div class="dialog-content">
   <div *ngIf="data.message"
         class="message-content">
        {{ data.message }}
    </div>
    <mat-form-field appearance="fill">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [formGroup]="range"
                              [rangePicker]="picker">
            <input matStartDate
                   formControlName="start"
                   placeholder="Start date">
            <input matEndDate
                   formControlName="end"
                   placeholder="End date">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix
                               [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date
        </mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date
        </mat-error>
    </mat-form-field>
</div>
<popup-button-container>
    <cas-button [btnText]="'Cancel'"
                (clickAction)="cancelAction()"></cas-button>

    <cas-button [disabled]="this.range.invalid"
    btnClass="md-raised md-accent"
                (clickAction)="confirmAction()"
                [btnText]="'Set'">
    </cas-button>
</popup-button-container>
